import { useSite } from "../contexts/SiteContext";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const { settings } = useSite();
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <div className="overline mb-3">Reach our concierge</div>
      <h1 className="font-display text-5xl text-dark tracking-tight mb-3">Get in Touch</h1>
      <p className="text-gray-700 leading-relaxed mb-12">For private viewings, bespoke requests, after-sales service, or authentication enquiries — our boutique team is here to assist.</p>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="card-luxe p-6"><Mail className="text-copper" size={20}/><div className="overline mt-3">Email</div><div className="text-dark text-sm mt-1 break-all">{settings.contact_email}</div></div>
        <div className="card-luxe p-6"><Phone className="text-copper" size={20}/><div className="overline mt-3">Phone</div><div className="text-dark text-sm mt-1">{settings.contact_phone}</div></div>
        <div className="card-luxe p-6"><MapPin className="text-copper" size={20}/><div className="overline mt-3">Boutique</div><div className="text-dark text-sm mt-1">{settings.contact_address}</div></div>
      </div>
      <p className="text-gray-500 text-sm mt-10">Use the chat widget at the bottom right to send an instant message.</p>
    </div>
  );
}
